import api from '../../../api/api'
import * as ExerciseTypes from './Exercise.types'
import { Paginated } from 'utils/types'

export const getExercisesByBookId = (bookId: string) => api.get<ExerciseTypes.Exercise[]>(`/book/${bookId}/exercises`)

export const getDifficultWords = () => api.get<ExerciseTypes.DifficultWordsResponse>(`/difficult-words`)

export const createStudySet = (name: string, words?: string[]) =>
  api.post<ExerciseTypes.StudySet>(`/study-set`, { name, words })

export const addWordToStudySet = (setId: string, word: string) =>
  api.post<ExerciseTypes.StudySet>(`/study-set/${setId}/${word}`)

export const changeStudySetName = (setId: string, name: string) =>
  api.put<ExerciseTypes.StudySet>(`/study-set/${setId}`, { name })

export const deleteWordFromStudySet = (setId: string, word: string) =>
  api.delete<ExerciseTypes.StudySet>(`/study-set/${setId}/${word}`)

export const getStudySets = () => api.get<Paginated<ExerciseTypes.StudySet>>(`/study-set`, { params: { $limit: 50 } })

export const deleteStudySet = (setId: string) => api.delete(`/study-set/${setId}`)

export const getExercisesByType = (type: ExerciseTypes.ExerciseType) =>
  api.get<ExerciseTypes.Exercise[]>(`/exercise`, { params: { $filter: `type:${type}` } })
